import React from 'react';
import { X } from 'lucide-react';

export default function Modal({ title, onClose, children, footer, size = '', style }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${size}`} style={style} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="card-title">{title}</h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
